import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import { SimpleTreeView } from '@mui/x-tree-view';
import React, { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { ActionIcons } from '../../Iconography';
import { ExtendedTreeItem } from '../../v2/components/generic/ObjectTree/ExtendedTreeItemV3';
import { getLinkUrlSearchParams } from './linkProducers';
const debug = process.env.REACT_APP_DEBUG && false;
export const CategoryToTreeLeaf = ({ keyIn, navDefinition, contextObject }) => {
    const navigate = useNavigate();
    const key = `${keyIn}_${navDefinition.id}_leaf`;
    const categoryTreeItem = (_jsx(ExtendedTreeItem, { contextMenuComponentMap: navDefinition.contextMenuComponentMap,
        keyIn: key,
        itemId: navDefinition.id,
        slots: {
            endIcon: navDefinition.icon,
        },
        x: navDefinition.link ? (_jsx(Typography, { sx: { flexGrow: 1 }, onClick: (e) => {
                e?.preventDefault();
                e?.stopPropagation();
                if (navDefinition.link) {
                    navigate(getLinkUrlSearchParams({ link: '/' + navDefinition.link, contextObject }));
                    //setSearchParams( getLinkUrlSearchParams() )
                    debug && console.log('Cat tree event', navDefinition.link);
                }
            }, children: navDefinition.name })) : (_jsx(Typography, { sx: { flexGrow: 1 }, children: navDefinition.name })),
        children: navDefinition.children?.map((item) => CategoryToTreeLeaf({ keyIn, navDefinition: item, contextObject })) }, `${key}_Extended`));
    return categoryTreeItem;
};
export const NavDefinitionToTree = ({ keyIn, navDefinition, contextObject }) => {
    const [expandedItemIds, setExpandedItemIds] = React.useState([]);
    const key = `${keyIn}_${navDefinition.id}_${contextObject?.sk}_tree`;
    return (_jsx(Fragment, { children: _jsx(SimpleTreeView, { expandedItems: [...expandedItemIds], // this TreeView prop ∏is an array of itemIds which are expanded, not using
            slots: { collapseIcon: ActionIcons.NavigationCollapse, expandIcon: ActionIcons.NavigationExpand },
            onSelectedItemsChange: (event, itemIds) => {
                debug && console.log('handle onSelectedItemsChange');
                event.preventDefault();
                event.stopPropagation();
            },
            onExpandedItemsChange: (event, itemIds) => {
                debug && console.log('handle onExpandedItemsChange', itemIds);
                setExpandedItemIds(itemIds);
            },
            onItemFocus: (event, itemId) => {
                debug && console.log('handle onItemFocus');
                event?.preventDefault();
                event?.stopPropagation();
            },
            sx: { overflowX: 'hidden' },
            children: CategoryToTreeLeaf({ keyIn: key, navDefinition, contextObject }) }, `${key}_view`) }, key));
};
